// extracted by mini-css-extract-plugin
module.exports = {"title":"PopupHeader_title__bp2gC","description":"PopupHeader_description__p8h5v"};